<template>
  <div class="container">
    <div class="header-title">
      <el-button type="primary" size="mini" @click="moduleuploadDialog = true">上传检测框模块</el-button>
      <el-button type="primary" size="mini" @click="getList">刷新</el-button>
    </div>
    <vvTable
      :data="moduleList"
      :config="tableConfig"
      :height="700"
    >
      <template slot-scope="scope" slot="version_desc_slot">
        {{scope.row.version_desc ? scope.row.version_desc : '-'}}
      </template>
      <template slot-scope="scope" slot="date_slot">
        {{scope.row.add_ts | tsToDate}}
      </template>
      <template slot-scope="scope" slot="desc_slot">
        {{scope.row.desc ? scope.row.desc : '-'}}
      </template>
      <template slot-scope="scope" slot="state_slot">
        <el-tag type="success" v-if="scope.row.is_published === '1'" size="mini">已发布</el-tag>
        <el-tag type="danger" v-else size="mini">未发布</el-tag>
        <el-tag type="success" size="mini" v-if="scope.row.is_common === '1'">通用模型</el-tag>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <publishButton :moduleType="moduleType" :module_uuid="scope.row.model_uuid" @completed="getList"></publishButton>
        &nbsp;&nbsp;
        <viewPublish :id="scope.row.model_uuid" v-if="scope.row.is_published === '1'" :module-type="moduleType"></viewPublish>
        &nbsp;&nbsp;
        <el-button type="text" @click="copy(scope.row)" size="mini">复制链接</el-button>
        &nbsp;
        <el-button type="text" size="mini" @click="setCommon(scope.row.model_uuid)"
                   :disabled="scope.row.is_common === '1'">设为通用
        </el-button>
      </template>
    </vvTable>
    <el-dialog
      title="提示"
      :visible.sync="moduleuploadDialog"
      :before-close="handleClose"
      width="600">
      <el-form ref="moduleForm" :model="moduleForm" :rules="rules" label-width="100px">
        <el-form-item label="检测框bin" prop="model_url">
          <!--<el-input v-model="moduleForm.model_url" placeholder="识别模块"></el-input>-->
          <el-upload
            class="upload-demo"
            action=""
            :http-request="modelUpload"
            :before-upload="handleBeforeUpload"
            accept="bin"
            :limit="1"
            ref="apiUpload"
          >
            <el-button size="mini" type="primary">请上传检测框模型</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="模块备注" prop="model_name">
          <el-input size="mini" v-model="moduleForm.model_name" placeholder="模块备注"></el-input>
        </el-form-item>
        <el-form-item label="更新日志" prop="model_desc">
          <el-input size="mini" v-model="moduleForm.model_desc" placeholder="更新日志"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelUpload">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmUpload">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import aliOSSUpload from '@/lib/aliOSSUpload';
import vvTable from 'vue-virtual-table';
import md5 from 'js-md5';
import {apiGetRegionModelList, apiUploadRegionModel, apiSetCommonRegionModel} from '@/api';
import publishButton from './publishButton';
import viewPublish from '_c/viewPublish';

export default {
  name: 'regionModelAdmin',
  components: {
    vvTable,
    publishButton,
    viewPublish
  },
  data () {
    return {
      moduleType: 4,
      moduleList: [],
      rules: {
        model_url: [{ required: true, message: "请上传zip" }]
      },
      moduleuploadDialog: false,
      moduleForm: {
        model_url: "",
        model_desc: "", // 更新日志
        model_md5: "", // desc
        manual_upload: true,
        model_name: ""
      }
    };
  },
  mounted () {
    this.getList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    async setCommon (model_uuid) {
      try {
        await apiSetCommonRegionModel(model_uuid);
        this.$message.success('设置成功');
        this.getList();
      } catch (e) {
        console.log(e);
        this.$message.error('设置失败');
      }
    },
    copy (row) {
      this.$copyText(row.url).then((e) => {
        this.$message.success('复制成功');
      }).catch((e) => {
        this.console.log(e);
        this.$message.error('复制失败' + e);
      });
    },
    handleClose () {
      this.moduleuploadDialog = false;
      this.$refs['apiUpload'].clearFiles();
      this.$refs['moduleForm'].resetFields();
    },
    handleSelect () {

    },
    querySearch (val, cb) {
      let versions = this.api_version_list;
      cb(versions);
    },
    async confirmUpload () {
      this.$refs['moduleForm'].validate(async (valid) => {
        if (valid) {
          try {
            await apiUploadRegionModel(this.moduleForm);
            this.getList();
            this.cancelUpload();
            this.$message.success('上传成功');
          } catch (e) {
            this.$message.error('上传失败' + e.message);
          }
        }
      });
    },
    cancelUpload () {
      this.handleClose();
    },
    async modelUpload(options) {
      let file = options.file;
      const type = file.type;
      const name = file.name;
      console.log(file);
      if (name.indexOf('bin') !== -1) {
        // 上传module
        try {
          const {url} = await aliOSSUpload(
            {
              bucket: "zhiyan-app-upload",
              prefix: "zhiyan-app",
              name: file.name
            },
            file
          );
          this.$message.success("识别框模块上传成功");
          this.moduleForm.model_url = url;
        } catch (e) {
          console.log(e);
          this.$message.error(e.message);
        }
      } else {
        return this.$message.error('请上传bin文件');
      }
    },
    computedMd5(file) {
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let that = this;
      fileReader.onload = e => {
        const md5key = md5(e.target.result);
        that.moduleForm.model_md5 = md5key;
        // return md5key;
      };
    },
    handleBeforeUpload(file) {
      this.computedMd5(file);
    },
    async getList () {
      try {
        const res = await apiGetRegionModelList();
        this.moduleList = res.model_info_list;
      } catch (e) {
        this.$message.error('获取模块列表失败' + e.message);
      }
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters(['api_version_list']),
    tableConfig () {
      return [
        { prop: "version", name: "版本号" },
        { prop: "_action", name: "更新日志", actionName: "version_desc_slot" },
        { prop: "_action", name: "上传日期", actionName: "date_slot" },
        { prop: "_action", name: "模块备注", actionName: "desc_slot" },
        { prop: "_action", name: "状态", actionName: "state_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot", width: 300 }
      ];
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
  .container {
    position: relative;
    .header-title {
      position: absolute;
      top: -90px;
      left: 200px;
      z-index: 1000;
    }
  }
</style>
